import React from "react";
import * as Sentry from "@sentry/react";

import { Button } from "@common/button";

import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";

function UnExpectedErrorPage({ errorData, debuggerInitialized }: Props) {
  const sentryInitialized = React.useRef(debuggerInitialized);
  const { t } = useTranslation();

  const refresh = () => {
    localStorage.clear();
    location.replace("/");
  };

  React.useEffect(() => {
    if (!sentryInitialized.current) {
      const env = {
        "web.testing.planzone7.f10web.com": "testing",
        "web.staging.planzone7.f10web.com": "staging",
        "web.preprod.planzone7.com": "preprod",
        "web.planzone7.com": "prod",
        localhost: "local",
      };
      const currentEnv =
        env[window.location.hostname as keyof typeof env] || "local";

      Sentry.init({
        dsn: "https://01ed1c48d7d0d2b0c02fcd67cfdcd88e@o4508800639041536.ingest.de.sentry.io/4508805926551632",
        environment: currentEnv,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [window.location.hostname],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
      });

      sentryInitialized.current = true;
    }

    Sentry.captureMessage(
      (errorData.error as any)?.cause?.name || "Unexpected Error",
      {
        level: "error",
        extra: {
          ...errorData,
          ...localStorage,
        },
      },
    );
  }, []);

  return (
    <div className={styles.unExpectedErrorPage}>
      <div className={styles.page}>
        <div className={styles.main}>
          <Icon className={styles.icon} />
          <div className={styles.col}>
            <h1 className={styles.title}>{t("unExpectedErrorPage.title")}</h1>
            <p className={styles.message}>{t("unExpectedErrorPage.message")}</p>
            <div className={styles.buttons}>
              <Button press={refresh} type="submit">
                {t("unExpectedErrorPage.refresh")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { UnExpectedErrorPage };
